import React, { useState, useEffect } from "react";
import DevDataService from "../services/DevService";

const Dev = props => {
  const initialDevState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentDev, setCurrentDev] = useState(initialDevState);
  const [message, setMessage] = useState("");

  const getDev = id => {
    DevDataService.get(id)
      .then(response => {
        setCurrentDev(response.data ?? response);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getDev(props.match?.params?.id);
  }, [props.match?.params?.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentDev({ ...currentDev, [name]: value });
  };

  const updateDev = () => {
    DevDataService.update(currentDev.id || currentDev._id, currentDev)
      .then(response => {
        console.log(response.data);
        setMessage("Development transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteDev = () => {
    DevDataService.remove(currentDev.id || currentDev._id)
      .then(response => {
        console.log(response.data);
        props.history.push("/dev");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentDev ? (
        <div className="edit-form">
          <h4>Development Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentDev.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentDev.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentDev.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>

          <button className="badge badge-danger mr-2" onClick={deleteDev}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateDev}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on Development Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default Dev;
